module.exports = __webpack_public_path__ + "static/social2-799cfe12cc11857b303615b364a5cac2.jpg";